import { App } from "vue"
import Vue3Toastify, { toast, type ToastContainerOptions } from "vue3-toastify"
import "vue3-toastify/dist/index.css"

const vue3ToastContainerOptions: ToastContainerOptions = {
    autoClose: 6000,
    closeButton: true,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    hideProgressBar: false,
    icon: true,
    rtl: false,
    newestOnTop: true,
    multiple: false,
    bodyClassName: "toastify-body",
    position: "bottom-left",
    clearOnUrlChange: false,
    limit: 1,
}

export default {
    install(app: App) {
        app.use(Vue3Toastify, vue3ToastContainerOptions)
        app.config.globalProperties.$toast = toast
    },
}

export { toast }
